import * as React from 'react';
import clsx from 'clsx';
import { Link } from "react-router-dom"
import customStyles from "../../../assets/styles/customStyles";
import { Row, Col } from "antd";
import Text from "antd/es/typography/Text";
import { deliveryMenus } from "../../../config/constant";



const Menus = () => {
    const classes = customStyles();
    return (
        <div className={clsx(classes.primaryPaper, classes.primaryMenu)}>
            <div style={{ height: '100%', overflow: "hidden", overflowY: "auto", paddingRight: 5 }}>
                <Row gutter={16}>
                    <Col>
                        <Text type="secondary" className={classes.margin20tb}>{deliveryMenus.sub[0].menu}</Text>
                        {deliveryMenus.sub[0].sub.map((menus, i) => {
                            return (
                                <div key={i} className={classes.margin10t} >
                                    <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                </div>
                            )
                        })
                        }
                    </Col>
                    <Col>
                        <Text type="secondary" className={classes.margin20tb}>{deliveryMenus.sub[1].menu}</Text>
                        {deliveryMenus.sub[1].sub.map((menus, i) => {
                            return (
                                <div key={i} className={classes.margin10t} >
                                    <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                </div>
                            )
                        })
                        }
                    </Col>
                    <Col>
                        <Text type="secondary" className={classes.margin20tb}>{deliveryMenus.sub[2].menu}</Text>
                        {deliveryMenus.sub[2].sub.map((menus, i) => {
                            return (
                                <div key={i} className={classes.margin10t} >
                                    <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                </div>
                            )
                        })
                        }
                    </Col>
                    <Col>
                        <Text type="secondary" className={classes.margin20tb}>{deliveryMenus.sub[3].menu}</Text>
                        {deliveryMenus.sub[3].sub.map((menus, i) => {
                            return (
                                <div key={i} className={classes.margin10t} >
                                    <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                </div>
                            )
                        })
                        }
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Menus